import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../utils/config';
import Sidebar from '../components/sidebar';

import MCXTable from '../components/dashboard/mcxtable';
import TelegramWidget from '../components/widget/telegramWidget';
const MCXDashBoard = () => {

 
    const [MCXData, setMCXData] = useState([]);
    const [screenerRecord, setScreenerRecord] = useState(0)
    const [AutomateMCXData, setAutomateMCXData] = useState([]);
    let count = 0;

    useEffect(() => {
        const fetchDataInterval = setInterval(async () => {

            await fetchMCXData();
        }, 60000); //0,000 milliseconds = 1 minute


        fetchMCXData()
        // // Initial fetch when count is 0
        // if (count === 0) {


        //     fetch(`${BASE_URL}/generatekitesession`, {
        //         method: 'GET'
        //     })
        //         .then(response => response.json())
        //         .then(res => {
        //             // Process the API response data
        //             // console.log(res);
        //             if (res.success === true) {
        //                 fetchMCXData();
        //             }
        //         })


        //     count += 1;
        // }

        // Cleanup the interval on component unmount
        return () => clearInterval(fetchDataInterval);
    }, [count]);

    const fetchMCXData = async () => {
        console.log("fetch record details")
        try {
            await fetch(`${BASE_URL}/getAllMCXdata`, {
                method: 'GET'
            })
                .then(response => response.json())
                .then(res => {

                    if (res.success === true) {
                        setMCXData(res.data);
                        setAutomateMCXData(res.data1);
                    } else {
                        console.log("data not found");
                    }

                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    return (
        <div>
            <Sidebar />
            <div className='Dashboard-container container-block'>
                <MCXTable Record={MCXData} Record1={AutomateMCXData} heading={'MCX Dashboard'} updateSLchange={fetchMCXData} RecordColor={screenerRecord} />
           <TelegramWidget/>
            </div>
        </div>
    );
};

export default MCXDashBoard;
